import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class RoleGrid extends BaseComponent {

		
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}

	constructor() {
		super();
		
		this.admin = false;
		
		var roleGrid = this;
		setTimeout(function(){
			roleGrid.init();
		});
	}

	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var roleGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (roleGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (roleGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_SECURITY_ROLES:WRITE', 'COMPANY_ROLE_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							addEditAction();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SECURITY_ROLES:WRITE', 'COMPANY_ROLE_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							addEditAction(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'manageusers',	
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SECURITY_ROLES:WRITE', 'COMPANY_ROLE_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:users', ' Manage Users')
					],
					listeners: {
						click: function() {							
							manageUsersAction(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;' + (roleGrid.admin ? 'margin-top: 18px;' : ''),
					permissions: ['COMPANY_ROLE_MANAGEMENT:DELETE', 'ADMIN_SECURITY_ROLES:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							deleteRoleAction(grid.selectedItems[0]);
						}
					}
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'roleId',
					header: 'Id',
					width: '9em'						
				},
				{						
					path: 'roleName',
					header: 'Name',
					width: '9em'
				},							
				{						
					path: 'roleDescription',
					header: 'Description',					
					width: '5em',
					'flex-grow': '1'
				},
				{
					path: 'adminRole',
					header: 'Admin Role',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'updateUser',
					header: 'Update User',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'updateDts',
					header: 'Update Date',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					},
					width: '5em'					
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'manageusers').disabled = false; 
						if (item.adminRole) {
							ElementUtil.query(toolbar, 'delete').disabled = true; 
						} else {
							ElementUtil.query(toolbar, 'delete').disabled = false; 
						}
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true; 
						ElementUtil.query(toolbar, 'manageusers').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true; 
					}	
				}
			}
		});
		
		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		roleGrid.append(gridLayout);
		
		var actionRefresh = function() {
						
			if(roleGrid.admin) {
				var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
				if (companyId) {
					var loadMask = grid.showLoading();
					Service.getSecurityService().getSecurityRoles(companyId).then(function(roles){
						grid.activeItem = null;
						grid.items = roles;
						loadMask.remove();
					});
				}
			} else {
				var loadMask = grid.showLoading();
				Service.getSecurityService().getSecurityRoles().then(function(roles){						
					grid.activeItem = null;
					grid.items = roles;
					loadMask.remove();
				});
			}
		};
		actionRefresh();
		
		var addEditAction = function(role) {
			
			var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
			if(roleGrid.admin && !companyId) {
				window.DL.MessageUtil.showOkMessage('Select a company first');
			} else {
				var showWin = function() {
					var addEditWin = ElementUtil.create({
						tag: 'dl-dialog',
						title: role ? 'Edit Role - ' + role.roleName : 'Add Role',
						icon: 'vaadin:edit',
						listeners: {
							ready: function() {

								addEditWin.show();						

								var permissionMap = {};

								var roleForm = ElementUtil.create({
									tag: 'dl-form-panel',
									children: [
										{
											tag: 'dl-flex-layout',
											children: [
												{
													tag: 'vaadin-form-layout',
													slot: 'toolbar',
													children: [
														{
															tag: 'vaadin-text-field',
															label: 'Name',
															name: 'roleName',
															maxlength: 255
														},
														{
															tag: 'vaadin-text-field',
															label: 'Description',
															name: 'roleDescription',
															maxlength: 255
														}
													]
												},
												{
													tag: 'vaadin-split-layout',
													slot: 'primary',
													style: 'height: 100%;',
													children: [
														{
															tag: 'dl-flex-layout',
															children: [
																{
																	tag: 'dl-toolbar',
																	itemid: 'permissionTools',
																	slot: 'toolbar',
																	theme: 'spacing',
																	children: [
																		{
																			tag: 'vaadin-button',
																			itemid: 'add',
																			'class': 'spacer-toolbar-item',
																			children:[
																				ElementUtil.makeIcon('vaadin:plus', ' Add')
																			], 
																			listeners: {
																				click: function() {

																					var addPermissionWin = ElementUtil.create({
																						tag: 'dl-dialog',
																						title: 'Add Permission',
																						icon: 'vaadin:plus',
																						width: 400,
																						height: 150,
																						listeners: {
																							ready: function() {
																								addPermissionWin.show();

																								var permissionForm = ElementUtil.create({
																									tag: 'dl-form-panel',
																									children: [
																										{
																											tag: 'vaadin-form-layout',
																											children: [
																												{
																													tag: 'vaadin-combo-box',
																													itemid: 'permissionCB',
																													name: 'permission',
																													colspan: 2,
																													label: 'Permission',
																													'item-value-path': 'code',
																													'item-label-path': 'description',
																													required: true,
																													postinit: function(combo) {
																														Service.getCompanyService().getPermissionsForCompany(companyId).then(function(data){
																															var available = [];
																															
																															//remove existing permissions
																															data.forEach(function(item) {
																																if (!permissionMap[item.code]) {
																																	available.push(item);
																																}
																															});

																															combo.items = available;
																														});
																													},
																													placeHolder: 'Select',
																													listeners: {
																														change: function() {
																															actionRefresh();
																														}
																													}
																												}
																											]
																										},
																										{
																											tag: 'hr'
																										}, 
																										{
																											tag: 'div',
																											style: 'text-align: center;',
																											colspan: 2,
																											defaults: {
																												tag: 'vaadin-button'
																											},
																											children: [
																												{
																													theme: 'primary',
																													children: [
																														ElementUtil.makeIcon('vaadin:plus', ' Add')
																													],
																													listeners: {
																														click: function() {		
																															//add permission
																															if (permissionForm.isValid()) {
																																var permission = ElementUtil.query(permissionForm, 'permissionCB').selectedItem;
																																permissionMap[permission.code] = {
																																	description: permission ? permission.description : 'Invaild',
																																	actions: {},
																																	availableActions: permission.availableActions
																																};
																																actionRefreshPermissions();
																																addPermissionWin.close();
																															}
																														}
																													}
																												},
																												{
																													theme: 'tertiary',
																													innerHTML: 'Cancel',
																													style: 'margin-left: 10px;',												
																													listeners: {
																														click: function() {
																															addPermissionWin.close();
																														}
																													}
																												}
																											]
																										}																								
																									]
																								});
																								addPermissionWin.addToContentElement(permissionForm);
																							}
																						}
																					});

																				}
																			}
																		},																																																				
																		{
																			tag: 'vaadin-button',						
																			theme: 'error primary',
																			itemid: 'delete',
																			disabled: true,
																			'class': 'spacer-toolbar-item',
																			style: 'float: right;',

																			children:[
																				ElementUtil.makeIcon('vaadin:trash', ' Delete')
																			],
																			listeners: {
																				click: function() {
																					var permissionGrid = ElementUtil.query(roleForm, 'permissionGrid');																					
																					actionDeletePermission(permissionGrid.selectedItems[0]);
																				}
																			}
																		},
																		{
																			tag: 'div',
																			'class': 'grid-title-center',
																			innerHTML: 'Permissions'
																		}

																	]
																}, 
																{
																	tag: 'vaadin-grid',
																	itemid: 'permissionGrid',
																	theme: 'row-stripes column-borders',
																	'column-reordering-allowed': '',
																	style: 'height: 100%;',			
																	slot: 'primary',
																	defaults: {
																		tag: 'vaadin-grid-sort-column',
																		resizable: true
																	},
																	children: [				
																		{						
																			path: 'code',
																			header: 'Id',
																			width: '9em'						
																		},																							
																		{						
																			path: 'description',
																			header: 'Description',					
																			width: '5em',
																			'flex-grow': '1'
																		}
																	],
																	listeners: {
																		'active-item-changed': function(event) {
																			const item = event.detail.value;
																			var permissionGrid = ElementUtil.query(roleForm, 'permissionGrid');
																			var permissionTools = ElementUtil.query(roleForm, 'permissionTools');
																			
																			permissionGrid.selectedItems = item ? [item] : [];
																			if (permissionGrid.selectedItems.length > 0) {																		
																				ElementUtil.query(permissionTools, 'delete').disabled = false; 
																				actionShowActions(permissionGrid.selectedItems[0]);
																			} else {
																				ElementUtil.query(permissionTools, 'delete').disabled = true;
																				
																				var actionContainer = ElementUtil.query(roleForm, 'actions');
																				actionContainer.innerHTML = '<- Select Permission to set actions';
																			}
																		}
																	}															
																}
															]
														},
														{
															tag: 'dl-flex-layout',
															children: [
																{
																	tag: 'div',
																	slot: 'toolbar',
																	'class': 'grid-title-center',
																	innerHTML: 'Actions'
																},
																{
																	tag: 'div',
																	itemid: 'actions',
																	slot: 'primary',
																	style: 'padding: 10px;',
																	trustedInnerHTML: true,
																	innerHTML: '<- Select Permission to set actions'
																}
															]
														}
													]
												},
												{
													tag: 'div',
													slot: 'footer',
													children: [
														{
															tag: 'hr'
														}, 
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {		
																			//submit form
																			roleForm.submitForm({		
																				preSubmit: function(data) {
																					var newRoleModel  = {
																						securityRole: {
																							companyId: roleGrid.admin ? companyId : null,
																							roleName: data.roleName,
																							roleDescription: data.roleDescription
																						},
																						permissions: []
																					};															
																					if (role) {
																						newRoleModel.roleId = role.roleId;
																					}
																					for (var permissionKey in permissionMap) {
																						var newPermission = {
																							securityPermssionId: permissionKey,
																							actions: []
																						};
																						
																						for (var actionKey in permissionMap[permissionKey].actions) {
																							newPermission.actions.push(actionKey);
																						} 
																						newRoleModel.permissions.push(newPermission);
																					}
																					
																					return newRoleModel;
																				},
																				actualCall: function(data) {
																					return Service.getSecurityService().saveSecurityRole(data);
																				},
																				success: function(data, responseData) {													
																					window.DL.MessageUtil.showToast('Success', 'Added Role', {									
																						theme: 'success',
																						position: 'top-stretch'
																					});
																					actionRefresh();
																					addEditWin.close();
																				}
																			});																			
																			
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',												
																	listeners: {
																		click: function() {
																			addEditWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										}
									]
								});

								addEditWin.addToContentElement(roleForm);						

								if (role) {
									roleForm.load(role);

									//load permissions
									Service.getSecurityService().getPermissionsInSecurityRole(role.roleId).then(function(fullRole){
										fullRole.permissions.forEach(function(permission){
											permissionMap[permission.securityPermssionId] = {											
												description: permission.securityPermission ? permission.securityPermission.description : 'Invaild',
												actions: {},
												availableActions: permission.securityPermission ? permission.securityPermission.availableActions : []
											};
											
											//set actions
											permission.actions.forEach(function(action){
												permissionMap[permission.securityPermssionId].actions[action] = true;
											});											
										});
										actionRefreshPermissions();
									});
								}
								
								var actionDeletePermission = function(permission) {
									delete permissionMap[permission.code];									
									actionRefreshPermissions();
								};
								
								var actionRefreshPermissions = function() {
									var permissionGrid = ElementUtil.query(roleForm, 'permissionGrid');
									
									var permissions = [];
									for (var permissionKey in permissionMap) {
										permissions.push({
											code: permissionKey,
											description: permissionMap[permissionKey].description											
										});
									}
									permissions = permissions.sort(function(a, b) {
										return a.code.localeCompare(b.code);
									});
									permissionGrid.activeItem = null;
									permissionGrid.items = permissions;
								};
								
								var actionShowActions = function(selectedPermission) {
									
									var permission = permissionMap[selectedPermission.code];
									var actionContainer = ElementUtil.query(roleForm, 'actions');
									
									ElementUtil.removeAllChildren(actionContainer);																		
									if (permission.availableActions.length > 0) {
										
										permission.availableActions.forEach(function(action) {
																						
											var config = {
												tag: 'vaadin-checkbox',
												label: StringUtil.capitalizeFirstLetter(action.replace(/_/g, ' ').toLowerCase()),
												value: action,
												listeners: {
													change: function(event){
														if (event.target.checked) {
															permission.actions[event.target.value] = true;
														} else {
															delete permission.actions[event.target.value];
														}
													}
												}
											};
											
											if (permission.actions[action]) {
												config.checked = true;
											}
											
											var checkbox = ElementUtil.create(config);
											actionContainer.append(checkbox, ElementUtil.create({tag: 'br'}));
										});										
										
									} else {
										actionContainer.innerHTML = 'No action are available for this permission';
									}
									
								};
							}
						}				
					});
				};
				
				if (!companyId) {
					Service.getCompanyService().getCurrentCompany().then(function(fullCompany){
						companyId = fullCompany.company.companyId;
						showWin();
					});
				} else {
					showWin();
				}
			}
			
		};
		
		var manageUsersAction = function(role) {
			
			var usersWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage Users',
				icon: 'vaadin:users',
				listeners: {
					ready: function() {
						
						usersWin.show();
						
						let draggedItems;
						let sourceGrid;
						
						var getGrids = function() {
							var userGrids = [];
							userGrids.push(ElementUtil.query(userPanel, 'inroleGrid'));
							userGrids.push(ElementUtil.query(userPanel, 'avaliableGrid'));
							return userGrids;
						};
						
						const dragStartListener = function(e) {
							draggedItems = e.detail.draggedItems;
							sourceGrid = e.target;
							getGrids().forEach(function (grid) {
								grid.dropMode = 'between';
							});
						};

						const dragEndListener = function (e) {
							draggedItems = sourceGrid = null;
							getGrids().forEach(function (grid) {
								grid.dropMode = null;
							});
						};

						const dropListener = function (e) {
							const dropTargetItem = e.detail.dropTargetItem;
							if (draggedItems.indexOf(dropTargetItem) === -1) {
								// Remove the items from the source grid
								sourceGrid.items = sourceGrid.items.filter(function (i) {
									return draggedItems.indexOf(i) === -1;
								});
								sourceGrid.selectedItems = [];

								// Add dragged items to the target Grid
								const targetGrid = e.target;
								let index = targetGrid.items.length;
								if (dropTargetItem) {
									index = targetGrid.items.indexOf(dropTargetItem)
											+ (e.detail.dropLocation === 'below' ? 1 : 0);
								}
								targetGrid.items = []
										.concat(targetGrid.items.slice(0, index))
										.concat(draggedItems)
										.concat(targetGrid.items.slice(index));
								
								if (targetGrid.gridId !== sourceGrid.gridId) {
									if (targetGrid.gridId === 'inroleGrid') {
										
										
										var loadMask = userPanel.showLoading('Adding User to Role...');
										Service.getSecurityService().addUserToSecurityRole(role.roleId, draggedItems[0].userId).then(function(result){
											loadMask.remove();
											
											window.DL.MessageUtil.showToast('Success', 'Added User to Role', {									
												theme: 'success'
											});
										});
										
									} else {
										
										var loadMask = userPanel.showLoading('Removing User from Role...');
										Service.getSecurityService().removeUserFromSecurityRole(role.roleId, draggedItems[0].userId).then(function(result){
											loadMask.remove();
											
											window.DL.MessageUtil.showToast('Success', 'Removed User from Role', {									
												theme: 'success'
											});
										});
									}
								}
							}
						};
						
						
						var userPanel = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'vaadin-split-layout',
									slot: 'primary',
									style: 'height: 100%;',
									children: [
										{
											tag: 'dl-flex-layout',
											children: [
												{
													tag: 'div',
													slot: 'toolbar',
													'class': 'grid-title-center',
													innerHTML: 'Available Users (Drag/Drop to Assign)'
												},
												{
													tag: 'vaadin-grid',
													itemid: 'avaliableGrid',
													properties: {
														gridId: 'avaliableGrid'
													},
													theme: 'row-stripes column-borders',
													'column-reordering-allowed': '',
													'rows-draggable': true,
													style: 'height: 100%;',			
													slot: 'primary',
													defaults: {
														tag: 'vaadin-grid-sort-column',
														resizable: true
													},
													listeners: {
														'grid-dragstart': dragStartListener,
														'grid-dragend': dragEndListener,
														'grid-drop': dropListener
													},
													children: [				
														{						
															path: 'userId',
															header: 'User Id',
															width: '5em'						
														},
														{						
															path: 'firstname',
															header: 'First name',
															width: '5em'						
														},
														{						
															path: 'lastname',
															header: 'Last name',
															width: '5em'						
														},	
														{						
															path: 'email',
															header: 'Email',
															width: '5em'						
														},
														{						
															path: 'primaryCompanyUser',
															header: 'Primary User',
															'text-align': 'center',
															width: '5em'						
														}
													]
												}
											]
										},
										{
											tag: 'dl-flex-layout',
											children: [
												{
													tag: 'div',
													slot: 'toolbar',
													'class': 'grid-title-center',
													innerHTML: 'Users In Role'
												},
												{
													tag: 'vaadin-grid',
													itemid: 'inroleGrid',
													properties: {
														gridId: 'inroleGrid'
													},
													theme: 'row-stripes column-borders',
													'column-reordering-allowed': '',
													'rows-draggable': true,
													style: 'height: 100%;',			
													slot: 'primary',
													defaults: {
														tag: 'vaadin-grid-sort-column',
														resizable: true
													},
													listeners: {
														'grid-dragstart': dragStartListener,
														'grid-dragend': dragEndListener,
														'grid-drop': dropListener
													},
													children: [				
														{						
															path: 'userId',
															header: 'User Id',
															width: '5em'						
														},
														{						
															path: 'firstname',
															header: 'First name',
															width: '5em'						
														},
														{						
															path: 'lastname',
															header: 'Last Name',
															width: '5em'						
														},	
														{						
															path: 'email',
															header: 'Email',
															width: '5em'						
														},
														{						
															path: 'primaryCompanyUser',
															header: 'Primary User',
															'text-align': 'center',
															width: '5em'						
														}
													]
												}
											]
										}
									]
								}
							]
						});
						usersWin.addToContentElement(userPanel);
						
						var actionLoadUsers = function() {
							
							var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
							
							var loadMask = userPanel.showLoading();
							Service.getSecurityService().getUsersInSecurityRole(role.roleId).then(function(roleUsers){
								Service.getUserService().getUsersForCompany(companyId).then(function(companyUsers){
									loadMask.remove();
									
									var availableUsers = [];
									var roleUserMap = {};
									roleUsers.forEach(function(user){
										roleUserMap[user.userId] = true;
									});
									companyUsers.data.forEach(function(user){
										if (!roleUserMap[user.userId]) {
											availableUsers.push(user);
										}
									});
									var inGrid = ElementUtil.query(userPanel, 'inroleGrid');
									var availableGrid = ElementUtil.query(userPanel, 'avaliableGrid');
									inGrid.items = roleUsers;
									availableGrid.items = availableUsers;
									
								});
							});
						};
						actionLoadUsers();
						
					}
				}				
			});
		};
		
		var deleteRoleAction = function(role) {

			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + role.roleName + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Role...');
							Service.getSecurityService().deleteSecurityRole(role.roleId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed: ' + role.roleName, {									
									theme: 'success'
								});
								actionRefresh();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};
		
	}
	

	
};
customElements.define('dl-role-grid', RoleGrid);

